import { Navigate, Route, Routes } from 'react-router-dom';

import GenerarPlan from './pantallas/GenerarPlan.jsx';
import GenerarPlanEnCurso from './pantallas/GenerarPlanEnCurso.jsx';
import PanelDelPlan from './pantallas/PanelDelPlan.jsx';
import VistaDelMes from './pantallas/VistaDelMes.jsx';

/**
 * Rutas internas del incremento 4/6 · Meses sin Intereses (RF-077, D-62).
 *
 * EL 4/6 NO LLAMA A RegistrarSeccionDeNavegacion, NO RECLAMA LUGAR EN LA BARRA
 * INFERIOR Y NO DESPLAZA A NINGÚN MÓDULO AL MENÚ SECUNDARIO. Cuelga del destino
 * "Cuentas" que el 2/6 ya registró, como TERCERA PESTAÑA junto a Cuentas y
 * Tarjetas. La barra sigue teniendo seis lugares y el sexto es de Ajustes (RN-044b,
 * RN-044c). Esto cierra la pregunta que el 2/6 dejó abierta en RF-042: el 4/6 no le
 * quita el lugar a nadie.
 *
 * Se presenta en tres puntos, todos dentro de destinos que ya existen:
 *   1. Esta pestaña, con la vista del mes y los planes vigentes.
 *   2. Un bloque en el detalle de la tarjeta.
 *   3. Un bloque en el detalle del gasto, o la acción "Generar plan" si aún no lo
 *      tiene (RF-074).
 */
export default function MesesSinIntereses() {
  return (
    <Routes>
      <Route index element={<VistaDelMes />} />
      <Route path="planes/:idPlan" element={<PanelDelPlan />} />
      <Route path="generar/:idMovimiento" element={<GenerarPlan />} />
      {/* [NUEVO · incremento 19/21 · RF-255] La compra a meses que empezo ANTES de
          llevar la aplicacion. Cuelga del mismo destino y de la misma pestana: un
          solo mecanismo de planes (D-408), no un modulo paralelo. */}
      <Route path="en-curso" element={<GenerarPlanEnCurso />} />
      <Route path="*" element={<Navigate to="/cuentas/meses" replace />} />
    </Routes>
  );
}
